// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rp-drag {
  position: relative;
  padding: 4px;
}
.rp-drag-loading {
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  inset: 0;
  cursor: initial;
  background-color: rgba(0, 0, 0, 0.25);
  border-radius: 8px;
}
.rp-drag-loading > svg {
  width: 24px;
  height: 24px;
  color: #fff;
  animation: rotating 1s infinite linear;
}
.rp-drag-disabled::after {
  content: "";
  position: absolute;
  background-color: rgba(255, 255, 255, 0.65);
  inset: 0;
  cursor: no-drop;
}
@keyframes rotating {
  100% {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Drag/style.less"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,YAAA;AACJ;AACI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,qCAAA;EACA,kBAAA;AACR;AAXI;EAaQ,WAAA;EACA,YAAA;EACA,WAAA;EACA,sCAAA;AACZ;AAKI;EACI,WAAA;EACA,kBAAA;EACA,2CAAA;EACA,QAAA;EACA,eAAA;AAHR;AAOA;EACI;IACI,yBAAA;EALN;AACF","sourcesContent":[".rp-drag {\n    position: relative;\n    padding: 4px;\n    \n    &-loading {\n        width: 100%;\n        height: 100%;\n        position: absolute;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        inset: 0;\n        cursor: initial;\n        background-color: rgba(0, 0, 0, .25);\n        border-radius: 8px;\n        \n        > svg {\n            width: 24px;\n            height: 24px;\n            color: #fff;\n            animation: rotating 1s infinite linear;\n        }\n    }\n}\n\n.rp-drag-disabled {\n    &::after {\n        content: \"\";\n        position: absolute;\n        background-color: rgba(255, 255, 255, .65);\n        inset: 0;\n        cursor: no-drop;\n    }\n}\n\n@keyframes rotating {\n    100% {\n        transform: rotate(360deg)\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
